export default "__VITE_ASSET__DyGjU1HU__"